<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;width: 100%;min-width:1050px">
      <el-form :inline="true" :model="filters">
        <!-- <el-form-item>
          <el-input v-model="filters.name" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getUsers">查询</el-button>
        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="users" style="width: 100%;" stripe>
      <el-table-column prop="uid" label="UID" min-width="60px"></el-table-column>
      <el-table-column prop="username" label="姓名" min-width="70px"></el-table-column>
      <el-table-column prop="group_name" label="身份"></el-table-column>
      <el-table-column prop="last_login_time" label="最后登录时间" min-width="120px"></el-table-column>
      <el-table-column prop="last_login_ip" label="最后登录ip" min-width="80px"></el-table-column>
      <el-table-column prop="status" label="状态"></el-table-column>
      <el-table-column prop="address" label="操作" min-width="440px">
        <template slot-scope="scope" v-if="scope.row.uid!=1">
          <!-- <template slot-scope="scope"> -->
          <el-button size="mini" type="primary" @click="authorizeProduct(scope)">产品授权</el-button>
          <el-button size="mini" type="primary" @click="authorize(scope)">用户组授权</el-button>
          <el-button
            size="mini"
            :type="scope.row.status=='正常'?'warning':'success'"
            @click="forbid(scope)"
          >{{scope.row.status=='正常'?"禁用":"恢复"}}</el-button>
          <el-button size="mini" type="danger" @click="handleDel(scope)">删除</el-button>
          <el-button size="mini" type="info" @click="upwd(scope)">修改密码</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!--用户组授权产品编辑界面-->
    <el-dialog
      title="产品授权"
      width="1400px"
      :visible.sync="editAppListVisible"
      :close-on-click-modal="false"
      class="appDialog"
    >
     <el-row :gutter="15">
     	<el-col :span="24">
     		<div class="tt">用户组   
 			 	<el-radio-group v-model="level" style="margin-left: 15px;">
					    <el-radio :label="index" v-for="item,index in rule_app_levels">{{item}}</el-radio>
					</el-radio-group>
     			
     		</div>
     	
     	</el-col>
     	
     	<el-col :span="24">
     		<el-tabs v-model="status" type="card">
			    <el-tab-pane label="内部游戏" name="0">
			    	<div class="tt">  
		     				<el-button size="mini" type="primary" @click="checkAll('0')" style="margin-left:10px">全选</el-button>
		     			  <el-button size="mini" type="default" @click="checkCancelAll('0')" style="margin-left:10px">清除</el-button>
		     		</div>
		     		 <el-checkbox-group v-model="checkboxInnerAPP" size="small">
		     		 		<div class="plamBox" v-for="(value, key) in appList[0]">
		     		 				<div class="innerName">{{key}}</div>
		     		 				<el-checkbox :label="g.id" border  v-for="(g,index) in value"  class="appCheckbox">{{g.name}}</el-checkbox>
		     		 		</div>
					    </el-checkbox-group>
			    </el-tab-pane>
			    <el-tab-pane label="外部游戏" name="1">
			    	<div class="tt">
		     			 <el-button size="mini" type="primary" @click="checkAll('1')" style="margin-left:10px">全选</el-button>
		     			 <el-button size="mini" type="default" @click="checkCancelAll('1')" style="margin-left:10px">清除</el-button>
		     		</div>
		     	 	<el-checkbox-group v-model="checkboxOuterAPP" size="small">
		     		 		<div class="plamBox" v-for="(value, key) in appList[1]">
		     		 				<div class="innerName">{{key}}</div>
		     		 				<el-checkbox :label="g.id" border  v-for="(g,index) in value"  class="appCheckbox">{{g.name}}</el-checkbox>
		     		 		</div>
					   </el-checkbox-group>
			    </el-tab-pane>
			 
			  </el-tabs>
     	</el-col>
     </el-row>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editAppListVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editAppsSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--用户组授权编辑界面-->
    <el-dialog
      title="用户组授权"
      width="600px"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-radio-group v-model="radio" label-position="top">
        <el-radio :label="g.id" v-for="(g,index) in groupList" :key="index">{{g.title}}</el-radio>
      </el-radio-group>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增用户"
      width="400px"
      :visible.sync="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="top"
        :model="ruleForm2"
        status-icon
        :rules="rules2"
        ref="ruleForm2"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名" prop="name">
          <el-input type="text" v-model="ruleForm2.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <el-input type="password" v-model="ruleForm2.pass" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="addSubmit('ruleForm2')" :loading="addLoading">提交</el-button>
          <el-button @click="resetForm('ruleForm2')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="updatePwd" width="400px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="请输入新密码" label-width="120px" prop="new_password">
          <el-input style="width:200px" v-model="form.new_password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" label-width="120px" prop="checkPass">
          <el-input style="width:200px" v-model="form.checkPass" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updatePwd = false">取 消</el-button>
        <el-button type="primary" @click="changePwd">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../common/js/util";
//import NProgress from 'nprogress'
import {
  getUserList, //获取列表
  forbidUser, //禁用删除用户
  getGroupList, //获取用户组列表
  setUserGroup, //设置用户分组
  addUser, //增加用户
  getUserListPage,
  removeUser,
  batchRemoveUser,
  editUser,
  scpwd,
  getAppList,
  getUserApp,
  setUserApp,
} from "../../api/api";

export default {
  data() {
    var nPass = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("新密码不能为空!"));
      } else if (value.length < 6) {
        callback(new Error("密码长度不能低于6位"));
      } else {
        callback();
      }
    };
    var vPass = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("确认密码不能为空!"));
      } else if (value !== this.form.new_password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var vPass1 = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("确认密码不能为空!"));
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      users: [], //用户列表
      editFormVisible: false, //授权界面是否显示
      editAppListVisible:false, //授权产品界面是否显示
      groupList: [],
      appList:[],
      checkboxInnerAPP:[],
      checkboxOuterAPP:[],
      radio: "1", //选中的列表项
      selectedUser: null, //选中的用户ID
      addFormVisible: false, //新增界面是否显示

      ruleForm2: {
        name: "",
        pass: "",
        checkPass: ""
      },
      rules: {
        new_password: [{ required: true, validator: nPass, trigger: "blur" }],
        checkPass: [{ validator: vPass, required: true, trigger: "blur" }]
      },
      rules2: {
        pass: [{ required: true, validator: nPass, trigger: "blur" }],
        checkPass: [{ validator: vPass1, required: true, trigger: "blur" }]
      },
      filters: {
        name: ""
      },
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      editLoading: false,
      addLoading: false,

      updatePwd: false,
      form: { new_password: "" },
      rule_app_levels:[],
      level:'',
      status:0,
    };
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        if (that.editFormVisible) {
          that.editSubmit();
        } else if (that.addFormVisible) {
          that.addSubmit("ruleForm2");
        } else if (that.updatePwd) {
          that.changePwd();
        }
        // that.addSubmit();
        return false;
      }
    };
  },
  methods: {
		 getConfig() {
      if (this.$store.config) {
    
        this.rule_app_levels = this.$store.config.rule_app_level;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
  	checkAll(s){
  		if(s==0){
  			this.checkboxInnerAPP =[];
  			for(let key  in this.appList[0]){
			      this.appList[0][key].forEach((v,i)=>{
		  				this.checkboxInnerAPP.push(v.id)
		  			})
			  }
  		
  		}
  		else if(s==1){
  			this.checkboxOuterAPP =[];
  			for(let key  in this.appList[1]){
			      this.appList[1][key].forEach((v,i)=>{
		  				this.checkboxOuterAPP.push(v.id)
		  			})
			  }
  		}
  	},
  	checkCancelAll(s){
  		if(s==0){
  			this.checkboxInnerAPP =[];
  			
  		}
  		else if(s==1){
  			this.checkboxOuterAPP =[];
  			
  		}
  	},
    upwd(s) {
      this.form = { uid: s.row.uid, new_password: "" };
      this.updatePwd = true;
    },
    changePwd() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          scpwd(this.form, this.$cookie.getCookie("login")).then(res => {
            if (res.code == 200) {
              this.updatePwd = false;
              this.$message({ message: "修改密码成功", type: "success" });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }
          });
        }
      });
    },
    //获取用户列表
    getUsers() {
      this.listLoading = true;
      getUserList(this.$cookie.getCookie("login")).then(res => {
        if (res.data.code == 200) {
          this.users = res.data.data.list;
          this.users.forEach((v, i) => {
            v.status =
              v.status == 1 ? "正常" : v.status == 0 ? "禁用" : "已删除";
          });
          this.listLoading = false;
        } 
        else if(res.data.code == 401){
        	this.$router.push('/401')
        }
        else {
          this.$message({
            message: res.data.msg,
            type: "error"
          });
        }
      });
    },
    getApps(){
    	getAppList(this.$cookie.getCookie("login")).then( res =>{
    			if(res.data.code==200){
    				var arr = res.data.data;
    				this.appList=[[],[]]
    				
    				this.appList[1] =arr.outgame;
    				
    				this.appList[0]= arr.ingame;
    					
    								
    			}
    		
    	})
    },
    //禁用用户
    forbid(s) {
      var status = this.users[s.$index].status == "禁用" ? 1 : 0;
      forbidUser(
        { uid: this.users[s.$index].uid, status },
        this.$cookie.getCookie("login")
      ).then(res => {
        if (res.data.code == 200) {
          this.getUsers();
          this.$message({
            message: status == 1 ? "启用成功" : "禁用成功",
            type: "success"
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error"
          });
        }
      });
    },
    //产品授权
    authorizeProduct(s){
    	this.checkboxInnerAPP=[];
    	this.checkboxOuterAPP=[];
    	
    	this.selectedUser = this.users[s.$index].uid;
    	this.editAppListVisible = true;
    	getUserApp(this.selectedUser, this.$cookie.getCookie("login")).then(res=>{
    		if (res.data.code == 200) {
    			var arr = res.data.data.app_ids.split(',');
    			this.level = parseInt(res.data.data.level);
    			for(let key  in this.appList[0]){
				      this.appList[0][key].forEach((v,i)=>{
			  				if(arr.indexOf(v.id)!=-1 ){
		    					this.checkboxInnerAPP.push(v.id);
		    				}
			  			})
				  }
    			for(let key  in this.appList[1]){
				      this.appList[1][key].forEach((v,i)=>{
			  				if(arr.indexOf(v.id)!=-1 ){
		    					this.checkboxOuterAPP.push(v.id);
		    				}
			  			})
				  }
    		}
    	})
    	
    },
    //模块授权
    authorize(s) {
      (this.selectedUser = this.users[s.$index].uid),
        getGroupList(
          this.users[s.$index].uid,
          this.$cookie.getCookie("login")
        ).then(res => {
          if (res.data.code == 200) {
            this.groupList = res.data.data;
            res.data.data.forEach((v, i) => {
              if (v.check == 1) {
                this.radio = v.id;
                return;
              }
            });
            this.editFormVisible = true;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
    },
    //删除
    handleDel(s) {
      this.$confirm("确认删除该用户吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          forbidUser(
            { uid: this.users[s.$index].uid, status: -1 },
            this.$cookie.getCookie("login")
          ).then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: "删除用户成功",
                type: "success"
              });
              this.getUsers();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }
          });
        })
        .catch(() => {});
    },
    //显示新增界面
    handleAdd: function() {
      this.addFormVisible = true;
      this.resetForm();
    },
    //改变用户分组编辑
    editSubmit: function() {
      this.editLoading = true;
      setUserGroup(
        { uid: this.selectedUser, group_id: this.radio },
        this.$cookie.getCookie("login")
      ).then(res => {
        if (res.data.code == 200) {
          this.editFormVisible = false;
          this.$message({
            message: "用户授权成功",
            type: "success"
          });
          this.getUsers();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error"
          });
        }
        this.editLoading = false;
      });
    },
    //改变用户产品权限编辑
    editAppsSubmit: function() {
      this.editLoading = true;
      var app_ids = this.checkboxInnerAPP.concat(this.checkboxOuterAPP);
      setUserApp(
        { uid: this.selectedUser, app_ids: app_ids.toString(),level:this.level },
        this.$cookie.getCookie("login")
      ).then(res => {
        if (res.data.code == 200) {
          this.editAppListVisible = false;
          this.$message({
            message: "用户授权成功",
            type: "success"
          });
          this.getUsers();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error"
          });
        }
        this.editLoading = false;
      });
    },
    //新增
    addSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.addLoading = true;
          addUser(
            { username: this.ruleForm2.name, password: this.ruleForm2.pass },
            this.$cookie.getCookie("login")
          ).then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: "新增用户成功",
                type: "success"
              });
              this.addFormVisible = false;

              this.getUsers();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }
            this.addLoading = false;
          });
        } else {
          this.$message({
            message: "请检查格式是否正确",
            type: "error"
          });
        }
      });
    },
    resetForm() {
      this.addLoading = false;
      this.ruleForm2 = {
        name: "",
        pass: "",
        checkPass: ""
      };
    },
    selsChange: function(sels) {
      this.sels = sels;
    }
  },
  mounted() {

    this.getUsers();
    this.getApps();
    this.getConfig();
    
  }
};
</script>

<style type="text/scss" scoped="scoped">
	.appDialog .tt{
		padding:15px;
		font-size: 18px;
		font-weight: bold;
	}
	.appDialog .appCheckbox{
		margin:5px 10px;
		width: 140px;
	}
	.plamBox{
		margin-bottom: 15px;
		padding: 10px 0;
		border: 1px solid #F2F2F2;
	}
	.innerName{
		height: 30px;
		line-height: 30px;
		font-size: 16px;
		padding-left: 15px;
		font-weight: bold;
		color: #666666;
	}
</style>


// WEBPACK FOOTER //
// Table.vue?524993c6